import {
  SET_NETSPACE_LOADER,
  SET_NETSPACE_SNACKBAR,
  SET_HOST_WITH_ALERT,
  SET_SECURITY_ALERTS,
  SET_VISIBILITY,
  SET_CRITICALITY,
  SET_GROUPS,
  UPDATE_SELECTED_GROUP,
  SET_GROUP_COUNT,
  SET_SITEMAP_EXPAND_ACCORDION,
  SET_SITEMAP_EXPAND_ACCORDION_RESET,
  SET_ACCORDION_DATA,
  DEFAULT,
  CLOSE_NETSPACE_DRAWER,
  OPEN_NETSPACE_DRAWER,
  SET_PAGINATION_MODEL,
  CHANGE_TAG_MODAL_STATUS,
  SET_ACTIVE_NETMAP,
  SET_NETMAP_PROGRESS,
  SET_FILE_EDITABLE,
  SET_RELOAD_NETSPACE,
  defaultPaginationModel,
  SET_USER_TAGS_DROPDOWN,
  SET_SYSTEM_TAGS_DROPDOWN,
  SET_SECOND_TAG_VALUE,
  SET_NETSPACE_TABLE_FILTERS,
  SET_NETSPACE_FILTER_OPTIONS,
  SET_CVE_BY_SEVERITIES,
  SET_HIGHEST_CVE_SEVERITY,
  SET_CVE_IDS,
  SET_OS_TYPES,
  SET_SOURCE_TYPES,
  SET_CVE_BY_SEVERITIES_DASHBOARD,
  SET_CVE_IDS_DASHBOARD,
  SET_HIGHEST_CVE_SEVERITY_DASHBOARD,
  SET_SIDE_DRAWER_ALERTS,
  SET_SELECTED_LABEL,
  SET_CVE_LIST_BY_SEVERITY,
} from "./NetSpaceConstant";
import { cloneDeep, update } from "lodash";

const initialState = {
  loader: false,
  snackBar: false,
  snackBarMessage: "",
  hostWithAlert: null,
  securityAlerts: null,
  cveBySeverity: null,
  highestCVESeverity: null,
  cveIds: null, 
  groups: [],
  groupCount: [],
  selectedGroup: DEFAULT,
  expandAccordion: {},
  accordionData: {},
  selectedHost: null,
  drawerIsOpen: false,
  isTagModalOpen: false,
  selectedTagData: [],
  selectedTagNodeId: null,
  nmapProgressData: null,
  activeNetMap: null,
  reloadNetspace: false,
  isFileEditable: false,
  updateTagGroup: null,
  componentLoader: {
    GET_HOST_WITH_ALERTS: false,
    GET_SECURITY_ALERTS: false,
    GET_VISIBILITY: false,
  },
  userTagDropdownValues: [],
  systemTagDropdownValues: [],
  netSpaceSecondTagValue: "",
  netSpaceTableFilters: {},
  netSpaceFilterOptions: {},
  selectedLabel: null,
  cveAccordionData:null,
}

export const NetspaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NETSPACE_LOADER: {
      if (action.payload.key) {
        return {
          ...state,
          componentLoader: {
            ...state.componentLoader,
            [action.payload.key]: action.payload.value,
          },
        };
      } else {
        return {
          ...state,
          loader: action.payload,
        };
      }
    }
    case SET_NETSPACE_SNACKBAR: {
      return {
        ...state,
        snackBar: action.payload.status,
        snackBarMessage: action.payload.message,
      };
    }
    case SET_HOST_WITH_ALERT: {
      return {
        ...state,
        hostWithAlert: action.payload.hostWithAlert,
      };
    }
    case SET_CVE_BY_SEVERITIES: {
      return {
        ...state,
        cveBySeverity: action.payload.cveBySeverity,
      };
    }
    case SET_HIGHEST_CVE_SEVERITY: {
      return {
        ...state,
        highestCVESeverity: action.payload.highestCVESeverity,
      };
    }
    case SET_SECURITY_ALERTS: {
      return {
        ...state,
        securityAlerts: action.payload.securityAlerts,
      };
    }
    case SET_VISIBILITY: {
      return {
        ...state,
        visibility: action.payload.visibility,
      };
    }
    case SET_CRITICALITY: {
      return {
        ...state,
        criticality: action.payload.criticality,
      };
    }
    case SET_OS_TYPES: {
      return {
        ...state,
        osTypes: action.payload.osTypes,
      };
    }
    case SET_SOURCE_TYPES: {
      return {
        ...state,
        sourceTypes: action.payload.sourceTypes,
      };
    }

    case SET_CVE_BY_SEVERITIES_DASHBOARD: {
      return {
        ...state,
        cveBySeverityDashboard: action.payload.cveBySeverityDashboard,
      };
    }

    case SET_CVE_IDS_DASHBOARD: {
      return {
        ...state,
        cveIdsDashboard: action.payload.cveIdsDashboard,
      };
    }

    case SET_HIGHEST_CVE_SEVERITY_DASHBOARD: {
      return {
        ...state,
        highestCVESeverityDashboard: action.payload.highestCVESeverityDashboard,
      };
    }

    case SET_GROUPS: {
      return {
        ...state,
        groups: [...action.payload.groups.content],
      };
    }
    case UPDATE_SELECTED_GROUP: {
      return {
        ...state,
        selectedGroup: action.payload,
      };
    }
    case SET_GROUP_COUNT: {
      const accordionData = {};
      Object.keys(action.payload.groupCount).forEach((element) => {
        accordionData[element] = {
          data: [],
          paginationModel: defaultPaginationModel,
        };
      });
      return {
        ...state,
        groupCount: action.payload.groupCount,
        selectedHost: null,
        drawerIsOpen: false,
        accordionData: { ...accordionData },
      };
    }
    case SET_SITEMAP_EXPAND_ACCORDION: {
      return {
        ...state,
        expandAccordion: { ...action.payload },
      };
    }
    case SET_NETMAP_PROGRESS: {
      return {
        ...state,
        nmapProgressData: action.payload.nmap_progress_data,
      };
    }
    case SET_CVE_IDS: {
      return {
        ...state,
        cveIds: action.payload,
      };
    }
    case SET_USER_TAGS_DROPDOWN: {
      return {
        ...state,
        userTagDropdownValues: action.payload,
      };
    }
    case SET_SYSTEM_TAGS_DROPDOWN: {
      return {
        ...state,
        systemTagDropdownValues: action.payload,
      };
    }
    case SET_ACTIVE_NETMAP: {
      return {
        ...state,
        activeNetMap: action.payload.active_nmap,
      };
    }
    case SET_SITEMAP_EXPAND_ACCORDION_RESET: {
      return {
        ...state,
        expandAccordion: { ...action.payload, ...state.expandAccordion },
      };
    }
    case SET_SECOND_TAG_VALUE: {
      return {
        ...state,
        netSpaceSecondTagValue: action.payload,
      };
    }
    
    case SET_ACCORDION_DATA: {
      let updatedSelectedHost = state.selectedHost;

      // Batched update path
      if (action.payload.batchedAccordionData) {
        const newAccordionData = { ...state.accordionData };

        Object.entries(action.payload.batchedAccordionData).forEach(
          ([accordionKey, accordionData]) => {
            const PageModel = state.accordionData[accordionKey]
              ? state.accordionData[accordionKey].paginationModel
              : defaultPaginationModel;

            newAccordionData[accordionKey] = {
              data: accordionData,
              paginationModel: PageModel,
              loading: false,
              fetched: true,
              lastFetchedAt: Date.now(),
            };

            // If drawer is open and host matches current accordion key
            if (
              state.drawerIsOpen &&
              updatedSelectedHost &&
              accordionData?.content?.some(
                (host) => host.nodeId === updatedSelectedHost.nodeId,
              )
            ) {
              updatedSelectedHost = accordionData.content.find(
                (host) => host.nodeId === updatedSelectedHost.nodeId,
              );
            }
          },
        );

        return {
          ...state,
          accordionData: cloneDeep(newAccordionData),
          selectedHost: { ...updatedSelectedHost },
        };
      }

      // Single update path (unchanged)
      const PageModel = state.accordionData[action.payload.accordionKey]
        ? state.accordionData[action.payload.accordionKey].paginationModel
        : defaultPaginationModel;

      if (state.drawerIsOpen && updatedSelectedHost) {
        updatedSelectedHost = action.payload.accordionData.content.find(
          (host) => host.nodeId === updatedSelectedHost.nodeId,
        );
      }

      return {
        ...state,
        accordionData: cloneDeep({
          ...state.accordionData,
          [action.payload.accordionKey]: {
            data: action.payload.accordionData,
            paginationModel: PageModel,
            loading: false,
            fetched: true,
            lastFetchedAt: Date.now(),
          },
        }),
        selectedHost: { ...updatedSelectedHost },
      };
    }

    case SET_CVE_LIST_BY_SEVERITY: {
      const { severity, cveMap } = action.payload;

      return {
        ...state,
        cveAccordionData: {
          ...state.cveAccordionData,
          [severity]: {
            ...state.cveAccordionData?.[severity],
            cveMap,
          },
        },
      };
    }

    case CLOSE_NETSPACE_DRAWER: {
      return {
        ...state,
        drawerIsOpen: false,
        selectedHost: null,
      };
    }
    case OPEN_NETSPACE_DRAWER: {
      return {
        ...state,
        drawerIsOpen: true,
        updateTagGroup: action.payload.updateTagGroup,
        selectedHost: action.payload.selectedHost,
      };
    }
    case SET_PAGINATION_MODEL: {
      return {
        ...state,
        accordionData: {
          ...state.accordionData,
          [action.payload.key]: {
            ...state.accordionData[action.payload.key],
            paginationModel: action.payload.newModel,
          },
        },
      };
    }
    case CHANGE_TAG_MODAL_STATUS: {
      return {
        ...state,
        isTagModalOpen: action.payload.isTagModalOpen,
        selectedTagData: action.payload.selectedTagData,
        selectedTagNodeId: action.payload.selectedTagNodeId,
        updateTagGroup:
          action.payload.updateTagGroup === null ||
          action.payload.updateTagGroup === undefined
            ? state.updateTagGroup
            : action.payload.updateTagGroup,
      };
    }
    case SET_NETSPACE_TABLE_FILTERS: {
      const { group, filters, key, values } = action.payload;

      if (filters) {
        return {
          ...state,
          netSpaceTableFilters: {
            ...state.netSpaceTableFilters,
            [group]: filters,
          },
        };
      }

      return {
        ...state,
        netSpaceTableFilters: {
          ...state.netSpaceTableFilters,
          [group]: {
            ...(state.netSpaceTableFilters[group] || {}),
            [key]: values,
          },
        },
      };
    }

    case SET_NETSPACE_FILTER_OPTIONS: {
      const { group, options } = action.payload;
      return {
        ...state,
        netSpaceFilterOptions: {
          ...state.netSpaceFilterOptions,
          [group]: options,
        },
      };
    }

    case SET_FILE_EDITABLE: {
      return {
        ...state,
        isFileEditable: action.payload,
      };
    }
    case SET_RELOAD_NETSPACE: {
      return {
        ...state,
        reloadNetspace: action.payload,
      };
    }

    case SET_SELECTED_LABEL: {
      return {
        ...state,
        selectedLabel: action.payload,
      };
    }

    // ---- Side drawer alerts table -----
    case SET_SIDE_DRAWER_ALERTS: {
      return {
        ...state,
        sideDrawerAlerts: action.payload,
      };
    }

    default:
      return state;
  }
};
